import * as ActionsModal from "./Action";

export default {
  ...ActionsModal,
};
